var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wtpwady9na",
    x1: "8.392%",
    x2: "91.608%",
    y1: "91.608%",
    y2: "8.391%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#FF0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D800B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guchsvbvfb",
    x1: "14.645%",
    x2: "85.355%",
    y1: "85.355%",
    y2: "14.645%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#FF0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vbkdg0yx3c",
    x1: "14.647%",
    x2: "85.355%",
    y1: "85.354%",
    y2: "14.647%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F30072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E50097"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#wtpwady9na)",
    d: "M39.88 11.754c-.098-2.129-.436-3.583-.93-4.855-.502-1.334-1.29-2.543-2.307-3.542-.999-1.018-2.208-1.805-3.542-2.308-1.273-.494-2.726-.831-4.855-.928C26.113.023 25.432 0 20 0s-6.113.023-8.246.12C9.625.218 8.172.556 6.9 1.05c-1.334.502-2.543 1.29-3.542 2.307-1.018.999-1.805 2.208-2.308 3.542C.555 8.171.218 9.625.121 11.754.023 13.887 0 14.568 0 20s.023 6.113.12 8.246c.098 2.128.436 3.582.93 4.855.502 1.334 1.29 2.543 2.307 3.542 1 1.017 2.208 1.805 3.543 2.307 1.272.494 2.726.832 4.854.93 2.134.097 2.815.12 8.246.12 5.432 0 6.113-.023 8.246-.12 2.13-.098 3.583-.436 4.855-.93 2.686-1.04 4.81-3.163 5.849-5.85.495-1.272.832-2.726.93-4.854.097-2.133.12-2.814.12-8.246s-.023-6.113-.12-8.246zm-3.6 16.328c-.09 1.95-.415 3.009-.689 3.714-.673 1.744-2.051 3.123-3.796 3.795-.704.274-1.763.6-3.713.689-2.109.096-2.741.116-8.082.116-5.34 0-5.973-.02-8.082-.116-1.95-.089-3.009-.415-3.714-.689-.868-.32-1.654-.831-2.3-1.496-.664-.645-1.175-1.43-1.495-2.3-.274-.704-.6-1.763-.689-3.713-.096-2.109-.116-2.741-.116-8.082 0-5.34.02-5.973.116-8.082.09-1.95.415-3.009.689-3.713.32-.87.832-1.655 1.496-2.3.645-.665 1.43-1.176 2.3-1.496.704-.274 1.763-.6 3.713-.689 2.11-.096 2.742-.116 8.082-.116 5.34 0 5.973.02 8.082.116 1.95.09 3.008.415 3.713.689.869.32 1.655.832 2.3 1.496.664.645 1.175 1.43 1.496 2.3.274.704.6 1.763.689 3.713.096 2.11.116 2.742.116 8.082 0 5.34-.02 5.973-.116 8.082z",
    transform: "translate(-508 -2193) translate(508 2193)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guchsvbvfb)",
    d: "M20 9.73C14.328 9.73 9.73 14.328 9.73 20S14.328 30.27 20 30.27 30.27 25.672 30.27 20 25.672 9.73 20 9.73zm0 16.937c-3.682 0-6.667-2.985-6.667-6.667s2.985-6.667 6.667-6.667 6.667 2.985 6.667 6.667-2.985 6.667-6.667 6.667z",
    transform: "translate(-508 -2193) translate(508 2193)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vbkdg0yx3c)",
    d: "M33.076 9.324c0 1.325-1.075 2.4-2.4 2.4-1.326 0-2.4-1.075-2.4-2.4 0-1.326 1.074-2.4 2.4-2.4 1.325 0 2.4 1.074 2.4 2.4z",
    transform: "translate(-508 -2193) translate(508 2193)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.56f041f2.svg";
export { ForwardRef as ReactComponent };